angular.module('picmonicng').directive('playlists', [
  function () {
    return {
      restrict: 'E',
      controller: [
        '$scope',
        'PlaylistService',
        'BrowseService',
        'PicmonicQueue',
        '$filter',
        'UserService',
        'PrintAndGoService',
        '$state',
        '$modal',
        'StudySchedulerModal',
        function (
          $scope,
          PlaylistService,
          BrowseService,
          PicmonicQueue,
          $filter,
          UserService,
          PrintAndGoService,
          $state,
          $modal,
          StudySchedulerModal
        ) {
          $scope.PlaylistService = PlaylistService;
          $scope.Number = Number;

          $scope.playlistLoading = true;

          $scope.ellipsisState = { shareSubMenu: false };
          // Pass click event to the wrapper (ADA)
          $scope.passClick = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();
            angular.element($event.target).find('.ellipsis-wrapper').click();
          };
          $scope.toggleShareMenu = function () {
            $scope.ellipsisState.shareSubMenu = !$scope.ellipsisState.shareSubMenu;
            // Restore focus (ADA)
            if (!$scope.ellipsisState.shareSubMenu) {
              setTimeout(function () {
                angular.element('.share-submenu-open').focus();
              });
            } else {
              setTimeout(function () {
                angular.element('.share-submenu-close').focus();
              });
            }
          };

          $scope.togglePrintGoMenu = function () {
            $scope.ellipsisState.printGoSubMenu = !$scope.ellipsisState.printGoSubMenu;
          };

          function getBlockStats() {
            $scope.total = 0;
            $scope.total_mastered = 0;
            angular.forEach(PlaylistService.playlists, function (playlist) {
              $scope.total += playlist.total;
              $scope.total_mastered += playlist.total_mastered;
            });
            $scope.dataChanged = false;
          }

          $scope.sort_options = [
            { label: 'A-Z', value: 'name' },
            { label: 'Recent', value: '-last_viewed_at' },
            { label: 'Date Created', value: '-created_at' },
          ];

          $scope.display_options = [
            { label: 'GRID', value: 'grid', icon: 'view_module' },
            { label: 'LIST', value: 'list', icon: 'view_list' },
          ];

          $scope.ellipsisClick = function () {
            $scope.ellipsisState.shareSubMenu = false;
          };

          $scope.changeSorting = function ($item) {
            UserService.user.playlists_sort = $item.value;
            UserService.user.$update();
          };

          $scope.changeDisplayOption = function ($item) {
            if ($item && $item.value == 'list') {
              UserService.user.playlist_view_mode = 1;
            } else {
              UserService.user.playlist_view_mode = 0;
            }
            UserService.user.$update();
          };

          $scope.sorting =
            $filter('findInArray')($scope.sort_options, UserService.user.playlists_sort, 'value') ||
            $scope.sort_options[0];

          if (UserService.user.user_id) {
            $scope.display_option = $scope.display_options[UserService.user.playlist_view_mode];
          } else {
            $scope.display_option = $scope.display_options[1];
          }

          // If there's no playlist promise, assume the playlists have not been retrieved yet and init PlaylistService
          if (typeof PlaylistService.playlists.$promise == 'undefined') {
            PlaylistService.init().$promise.then(function () {
              $scope.playlistLoading = false;
              getBlockStats();
            });
          } else {
            PlaylistService.playlists.$promise.then(function () {
              $scope.playlistLoading = false;
              getBlockStats();
            });
          }

          $scope.goToPlaylist = function (playlist) {
            if ($scope.location == 'playlists') {
              BrowseService.go('app.playlists.playlist', {
                playlist_id: playlist.playlist_id,
              });
            } else {
              BrowseService.go('app.playlist', {
                playlist_id: playlist.playlist_id,
              });
            }
          };

          $scope.newPlaylist = function () {
            PlaylistService.create();
          };

          //Duplicate playlist then go to new playlist
          $scope.duplicate = function (playlist) {
            PlaylistService.duplicate(playlist);
          };

          //Rename playlist
          $scope.rename = function (playlist) {
            PlaylistService.rename(playlist).then(function (response) {
              playlist.name = response.name;
            });
          };

          //Delete a playlist
          $scope.delete = function (playlist) {
            PlaylistService.delete(playlist);
          };

          $scope.createStudySchedule = function (playlist) {
            StudySchedulerModal.show(null, null, playlist);
          };

          $scope.scrollToActivePlaylist = function () {
            if ($('.tile--playlist__active').length > 0) {
              $('.browse__content').animate(
                {
                  scrollTop: $('.tile--playlist__active').offset().top - $('.browse__content').offset().top - 8,
                },
                200
              );
            }
          };

          $scope.learnAll = function (playlist) {
            PicmonicQueue.setAndPlay(
              $filter('orderBy')(playlist.cards, ['viewed_flag', 'attempted_flag', 'mastered_flag', 'sort_order']),
              null,
              null,
              null,
              playlist.playlist_id
            );
            send_ga('event', 'Playlist', 'Learn Playlist');
          };

          $scope.startSpacedRep = function (playlist) {
            if (!UserService.user.has_seen.spaced_rep_filter) {
              $modal.open({
                templateUrl: '/templates/modals/quiz-spacedrep.html',
                windowClass: 'pls-modal-spaced-rep',
                size: 'md',
                backdropClass: 'above-nav',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.resourceName = playlist.name;

                    $scope.startSpacedRep = function () {
                      if ($scope.hideModal) {
                        UserService.see('spaced_rep_filter');
                      }

                      $state.go('app.quiz', {
                        card_id: null,
                        track_id: null,
                        pathway_id: null,
                        playlist_id: playlist.playlist_id,
                        quiz_type: 'spacedrep',
                        resource_id: 'today',
                      });
                    };
                  },
                ],
              });
            } else {
              $state.go('app.quiz', {
                playlist_id: playlist.playlist_id,
                quiz_type: 'spacedrep',
                resource_id: 'today',
              });
            }
          };

          $scope.print = function (playlist, layout) {
            PrintAndGoService.print('playlist', playlist.playlist_id, layout);
          };

          $scope.quizPlaylist = function (playlist) {
            PicmonicQueue.goToQuiz(playlist.playlist_id, 'playlist', playlist.total_facts, playlist.name);
          };

          var onChange = function () {
            $scope.dataChanged = true;
            getBlockStats();
          };

          var updateIfVisible = function () {
            if (BrowseService.browseOpen && !BrowseService.secondaryVisible && $scope.dataChanged) {
              onChange();
            }
          };

          $scope.$on('playlistDataChanged', onChange);
          $scope.$on('cardDataChanged', onChange);
          $scope.$on('browseVisibilityChange', updateIfVisible);

          $scope.studySchedulerEnabled =
            UserService.user.settings.show_study_scheduler ||
            UserService.user.email.indexOf('@picmonic.com') > -1 ||
            !UserService.user.is_trial;
        },
      ],
      templateUrl: '/templates/directives/playlists.html',
      link: function (scope, element, attrs) {
        scope.location = attrs.location;
      },
    };
  },
]);
